import { __assign, __extends } from "tslib";
import { deepMix, assign } from '@antv/util';
import { maybeAppend } from '../../util';
import { GUI } from '../../core/gui';
import { LABEL_TEXT_STYLE, CHECKBOX_RECT_STYLE, CHECKED_SHAPE_STYLE } from './constant';
function getLablePosition(shape, spacing) {
    var bounds = shape.getLocalBounds();
    return {
        x: bounds.halfExtents[0] ? bounds.max[0] + (spacing || 0) : shape.style.x,
        y: bounds.halfExtents[1] ? (bounds.min[1] + bounds.max[1]) / 2 : shape.style.y,
    };
}
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(options) {
        return _super.call(this, deepMix({}, Checkbox.defaultOptions, options)) || this;
    }
    Checkbox.prototype.render = function (attributes, container) {
        var label = attributes.label, boxStyle = attributes.boxStyle, checkedStyle = attributes.checkedStyle, checked = attributes.checked, spacing = attributes.spacing;
        this.checked = !!checked;
        var group = maybeAppend(container, '.checkbox-content', 'g').attr('className', 'checkbox-content').node();
        var checkboxBoxStyle = assign({}, this.checked ? CHECKBOX_RECT_STYLE.selected : CHECKBOX_RECT_STYLE.default, boxStyle);
        var checkboxBoxCheckedStyle = assign({}, CHECKED_SHAPE_STYLE, checkedStyle);
        this.checkboxBoxShape = maybeAppend(group, '.checkbox-box', 'rect')
            .styles(__assign({ className: 'checkbox-box', zIndex: (group.style.zIndex || 0) - 1 }, checkboxBoxStyle))
            .node();
        maybeAppend(this.checkboxBoxShape, '.checkbox-checked', 'path').styles(__assign({ className: 'checkbox-box-checked', stroke: '#fff' }, checkboxBoxCheckedStyle));
        var _a = getLablePosition(this.checkboxBoxShape, Number(spacing)), x = _a.x, y = _a.y;
        maybeAppend(group, '.checkbox-label', 'text').styles(__assign({ className: 'checkbox-label', x: x, y: y }, label));
    };
    /**
     * 组件 checkbox
     */
    Checkbox.tag = 'checkbox';
    /**
     * 默认配置项
     */
    Checkbox.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            label: __assign({ text: '' }, LABEL_TEXT_STYLE),
            spacing: 4,
            checked: false,
        },
    };
    return Checkbox;
}(GUI));
export { Checkbox };
//# sourceMappingURL=index.js.map